import type { CustomerAppConfigAuthError } from "@wayflyer/undercarriage";

export const getAuthErrorPath = (authError: CustomerAppConfigAuthError): string => {
  switch (authError.typ) {
    case "email_login_constraint":
      return `/authn-wf/email-constraint?to=${authError.shouldLoginAs}`;
    case "user_deactivated":
      return "/authn-wf/account-deactivated";
    default:
      authError satisfies never;
      return "/authn-wf/error";
  }
};
